import { FSDWaitlist } from '@/components/fsd/FSDWaitlist';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import type { Config } from '@/pageConfig/fsd';
import { FSD_LANDING_PAGE } from '@/utils/productAdaPages';
import Head from 'next/head';
import React from 'react';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

interface FSDTemplateProps {
  config: Config;
}

export const FSDPageTemplate: React.FC<FSDTemplateProps> = ({ config }) => {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
      </Head>
      <GlobalStyle />
      <Layout headerActions={config.layout.headerActions} page={FSD_LANDING_PAGE} overflow="visible" showFooter={false}>
        <SEO {...config.seo} />
        <FSDWaitlist />
      </Layout>
    </>
  );
};
